import React, {useEffect, useState} from 'react';
import {Box, Button, Typography, useTheme} from "@mui/material";
import Row from "../../../Common/Row";
import Column from "../../../Common/Column";
import {CategorySearch} from "./CategorySearch";
import {CategoryList} from "./CategoryList";
import {Section} from "../Section";
import {accountStore} from "../../../../Stores/AccountStore";
import {observer} from "mobx-react-lite";
import {categoryStore} from "../../../../Stores/CategoryStore";
import {useMediaContext} from "../../../../MediaContext";

const CategorySelection = () => {
    const isMobileSize = useMediaContext().isMobileSize;
    const theme = useTheme();
    const [mode, setMode] = useState(0);  // 0 = search, 1 = select from list
    const [isLoading, setIsLoading] = useState(true);

    const switchSearchMode = (newMode) => {
        setMode(newMode ?? !mode);
    }

    useEffect(() => {
        if (!categoryStore.isInitialized || !accountStore.isInitialized)
            return;

        setIsLoading(false)
    }, [categoryStore.isInitialized, accountStore.isInitialized]);


    if (isLoading) {
        return (
            <Section title="Vælg kategori">
                <Box sx={{padding: "20px"}}>
                    <Typography >Henter kategorier...</Typography>
                </Box>
            </Section>
        );
    }

    const SelectionButton = () => {
        return <Column sx={{width: "auto"}}>
            <Button
                variant="outlined"
                sx={{textTransform: "unset", fontSize: 16, whiteSpace: "nowrap"}}
                onClick={() => switchSearchMode()}
            >
                {mode ? "Søg i liste" : "Vælg fra liste"}
            </Button>
        </Column>
    };

    const SelectionBar = () => {
        return <Row sx={{paddingBottom: "25px"}}>
            <Box
                sx={{
                    border: "1px solid black",
                    borderRight: "none",
                    borderRadius: "5px 0 0 5px",
                    width: "100%",
                    padding: "3px",
                    textAlign: "center",
                    backgroundColor: mode ? "transparent" : theme.palette.jagtred.main,
                    color: mode ? "black" : "white",
                    cursor: mode ? "pointer" : "default",
                }}
                onClick={() => switchSearchMode(0)}
            >
                <Typography>Søg i liste</Typography>
            </Box>

            <Box
                sx={{
                    border: "1px solid black",
                    borderRadius: "0px 5px 5px 0px",
                    width: "100%",
                    padding: "3px",
                    textAlign: "center",
                    backgroundColor: mode ? theme.palette.jagtred.main : "transparent",
                    color: mode ? "white" : "black",
                    cursor: mode ? "default" : "pointer",
                }}
                onClick={() => switchSearchMode(1)}
            >
                <Typography>Vælg fra liste</Typography>
            </Box>
        </Row>
    };

    return (
        <Section title="Vælg kategori">
            <Box sx={{padding: "20px"}}>
                <Column>
                    {isMobileSize && <SelectionBar/>}

                    <Row sx={{alignItems: "start"}}>
                        <Box sx={{width: "100%"}}>
                            {mode ? <CategoryList /> : <CategorySearch/>}
                        </Box>
                        {!isMobileSize && <SelectionButton/>}
                    </Row>
                </Column>
            </Box>
        </Section>
    );
};


export default observer(CategorySelection);
